<template lang="pug">
  .b-base-input
    ._label(v-if="labelOuter && label") {{ label }}
      template(v-if="unit") , {{ unit }}
    input._field(
      :type="type"
      :placeholder="labelOuter ? '' : label"
      :class="{ error: !!error }"
      :value="value"
      :disabled="disabled"
      :name="name"
      :autocomplete="autocomplete"
      :data-testid="inputTestId"
      ref="input"
      v-on="inputListeners"
      )
    Icon.__icon(v-if="iconName" :name="iconName")
    ._unit(v-if="unit && !labelOuter") {{ unit }}
    ._error-text(v-if="error") {{ error }}
</template>

<script>
export default {
  name: 'BaseInput',
  props: {
    value: [String, Number],
    type: String,
    label: String,
    error: String,
    disabled: Boolean,
    name: String,
    autocomplete: String,
    unit: String,
    labelOuter: Boolean,
    iconName: String,
    /**
     * Тестовая метка на самом поле ввода: обёртка компонента — div, а сценариям нужно попадать в
     * элемент ввода (ТЗ 12.8). Тот же приём, что у FileDropzone.
     */
    inputTestId: String,
  },
  computed: {
    inputType() {
      switch (this.type) {
        case 'float':
        case 'int':
          return 'text';
        default:
          return this.type;
      }
    },
    inputListeners() {
      return {
        ...this.$listeners,
        input: (event) => this.$emit('input', event.target.value),
        change: (event) => {
          let { value } = event.target;

          if (this.type === 'float') {
            value = value.replace(',', '.');
          }

          this.$emit('input', value);
          this.$emit('change', value);
        },
      };
    },
  },
  methods: {
    focus() {
      this.$refs.input.focus();
    },
  },
};
</script>

<style scoped lang="scss">
.base-input {
  position: relative;

  &__label {
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.01em;
    color: #92A0B0;
    margin-bottom: 8px;
  }

  &__field {
    font-size: 13px;
    height: 39px;
    padding: 0 16px;
    border-radius: 6px;
    background-color: var(--color-super-light);
    color: var(--color-dark-gray);
    outline: none;
    font-weight: 500;
    box-sizing: border-box;
    display: block;
    width: 100%;
    border: 1px solid transparent;

    &[disabled] {
      color: var(--color-middle-gray);
    }

    &::placeholder {
      opacity: 1;
      font-size: 13px;
      color: var(--color-middle-gray);
      font-weight: 500;
    }

    &.error {
      border: 1px solid!important;
      color: var(--color-red)!important;
      margin-bottom: 4px!important;
    }
  }

  &__unit {
    position: absolute;
    bottom: 12px;
    right: 16px;
    font-size: 13px;
    color: var(--color-middle-gray);
  }

  &__icon {
    position: absolute;
    bottom: 12px;
    right: 16px;
  }

  &__error-text {
    max-width: 286px;
    text-align: left;
    color: var(--color-red)!important;
    letter-spacing: .01em;
    font-weight: 500;
    line-height: 13px;
    font-size: 10px;
    padding: 0 16px;
  }
}
</style>
